var React = require('react');

function PersonMaterial (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"#FFF","strokeWidth":"2","d":"M11 13.515c1.238 0 2.595.18 4.072.539 1.677.42 3.034.978 4.072 1.677C20.38 16.549 21 17.467 21 18.485V21H1v-2.515c0-1.018.619-1.936 1.856-2.754 1.038-.7 2.395-1.258 4.072-1.677 1.477-.36 2.834-.539 4.072-.539zM11 11a4.79 4.79 0 0 1-2.485-.674 5.081 5.081 0 0 1-1.811-1.811A4.79 4.79 0 0 1 6.03 6.03c0-.898.224-1.737.674-2.515a5.01 5.01 0 0 1 1.811-1.841A4.79 4.79 0 0 1 11 1a4.79 4.79 0 0 1 2.485.674 5.01 5.01 0 0 1 1.811 1.841c.45.778.674 1.617.674 2.515a4.79 4.79 0 0 1-.674 2.485 5.081 5.081 0 0 1-1.811 1.811A4.79 4.79 0 0 1 11 11z"}));
}

PersonMaterial.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = PersonMaterial;

PersonMaterial.default = PersonMaterial;
